{
  "categories": {
    "certificates": "Certificados",
    "dashboard": "Panel de control",
    "dataTransfer": "Transferencia de datos",
    "other": "Otro",
    "products": "Productos",
    "suppliers": "Proveedores"
  },
  "title": "FAQ"
}
